<template>
  <div class="landing-page-global">
    <div class="nav-bar">
      <div class="nav-bar-content">
        <div class="nav-bar-logo">
          <a href="https://www.simplybrand.com"><img src="@/assets/landing-page/img/logo-hd.png" alt="simplyBrand" /></a>
        </div>
        <div class="nav-bar-mobile">
          <el-button type="button" @click="showmenu"></el-button>
          <ul id="menuitems" v-if="showmobilemenu == true">
            <li><router-link to="/">Home</router-link></li>
            <li><a href="https://www.simplybrand.com/EN/about.html">About us</a></li>
            <li><a href="#requestdemo">Request Demo</a></li>
            <li><router-link to="/CN">中文</router-link></li>
            <li><router-link to="/JP">日本語</router-link></li>
          </ul>
        </div>
        <div class="nav-bar-menu">
          <ul>
            <li class="active-menu"><router-link to="/">Home</router-link></li>
            <li><a href="https://www.simplybrand.com/EN/about.html">About us</a></li>
          </ul>
        </div>
        <div class="nav-bar-signup">
          <router-link class="login-link" to="/Login/Default?lang=en">Login</router-link><a href="#requestdemo">Request Demo</a><router-link class="borderright1px border1" to="/CN">中文</router-link><router-link class="borderright1px" to="/JP">日本語</router-link>
        </div>
      </div>
    </div>

    <div class="section_01">
      <div class="section_01_content">
        <h2>Is your brand losing profitability<br/>due to unauthorized<br/>pricing & counterfeit products?</h2>
        <p>We protect your brand from unauthorized ecommerce activities,<br/>spot non-compliant pricing, and uncover counterfeits instantly.</p>
        <ul>
          <li class="active-button"><a href="#requestdemo">Experience Now</a></li>
          <!-- <li><a href="#requestdemo">Schedule a Demo</a></li> -->
        </ul>
        <div class="section_01_content_img">
          <img src="@/assets/landing-page/img/simplybrand-metrics.png" alt="Metrics" />
        </div>
      </div>
    </div>

    <div class="section_02">
      <div class="section_02_content">
        <h2>Protecting brands throughout the Asia Pacific</h2>
        <img src="@/assets/landing-page/img/allclients.png" alt="Protecting brands" />
      </div>
    </div>

    <div class="section_03">
      <div class="section_03_content">
        <div class="section_03_content_right">
          <h2>Putting efficiency at the core of brand protection</h2>
          <p>Reallocate your organization's resources to strategic activities while automating your brand protection process</p>
          <ul>
            <li class="icon_01">
              <h3>Ecommerce Risk Discovery & Analysis</h3>
              <p>Monitor resellers for price compliance with 24/7 tracking. Receive notifications when changes are spotted</p>
            </li>
            <li class="icon_02">
              <h3>Low-Price Detection</h3>
              <p>Receive alerts for products below the Minimum Advertised Price (MAP). Take immediate action to prevent brand devaluation</p>
            </li>
            <li class="icon_03">
              <h3>Unauthorized sellers</h3>
              <p>Uncover unauthorized sellers across more than 21,000 marketplaces and flag high-risk sellers. Use our seller intelligence to determine action plans</p>
            </li>
            <li class="icon_04">
              <h3>Counterfeit product identification</h3>
              <p>Discover counterfeits and IP infringements through our proprietary AI technology and receive recommendations for removal</p>
            </li>
          </ul>
          <a href="#">See Our Full List of Features</a>
        </div>
      </div>
    </div>

    <div class="section_04">
      <div class="section_04_content">
        <div class="section_04_header">
          <h2>Why choose simplyBrand?</h2>
          <p>simplyBrand provides a comprehensive solution that protects your brand from unauthorized ecommerce activities, spot non-compliant pricing, and uncover counterfeits instantly.</p>
        </div>
        <div class="section_04_body">
          <div class="section_04_body_item section_04_body_item_two">
            <div class="section_04_body_item_inner">
              <ul>
                <li class="item-header is-pc"><img src="@/assets/landing-page/img/logo-hd.png" alt="simplyBrand" /></li>
                <li class="item-header is-mb"><img src="@/assets/landing-page/img/logo-hd-m.png" alt="simplyBrand" /></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="icon_yes"></li>
                <li class="color-red">Automated</li>
                <li class="color-red">No overage fees</li>
                <li class="color-red">Low</li>
              </ul>
            </div>
          </div>
          <div class="section_04_body_item section_04_body_item_one">
            <div class="section_04_body_item_inner">
              <ul>
                <li class="item-header color-red">Features</li>
                <li>Data monitoring with AI</li>
                <li>Intelligence gathering through machine learning</li>
                <li>Intelligent identification of noncompliant sellers</li>
                <li>Intelligent identification of risk levels</li>
                <li>24/7 real-time monitoring</li>
                <li>Coverage of local and global marketplaces</li>
                <li>Request Demo</li>
                <li>Report generation</li>
                <li>Pricing mechanism</li>
                <li>Total cost outlay</li>
              </ul>
            </div>
          </div>
          <div class="section_04_body_item section_04_body_item_two">
            <div class="section_04_body_item_inner">
              <ul>
                <li class="item-header color-grey">Others</li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="icon_no"></li>
                <li class="color-grey">Manual</li>
                <li class="color-grey">Overage fees</li>
                <li class="color-grey">High</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="section_04_link">
          <a href="#">Get a Free Trial</a>
        </div>
        <div class="section_04_brands">
          <div class="section_04_brands_header">
            <h2>Successful brand protection efforts</h2>
            <p>Join hundreds of global brands using simplyBrand to enhance<br/>their brand protection efforts</p>
          </div>
          <div class="section_04_brands_body">
            <div class="section_04_brands_body_item">
              <div class="section_04_brands_body_inner">
                <img class="img1" src="@/assets/landing-page/img/logo_naturabisse.png" />
                <p>"Thank you for providing us with reliable data and analysis for our sales channel management, letting us better manage resellers and combat unauthorized selling activities. Your support and assistance have helped us to effectively uphold our brand image."</p>
              </div>
            </div>
            <div class="section_04_brands_body_item">
              <div class="section_04_brands_body_inner">
                <img class="img2" src="@/assets/landing-page/img/logo_montes.png" />
                <p>"simplyBrand has provided us with a set of very effective brand protection strategies. Its highly effective monitoring system and responsive team have alo greatly reduced our resource outlay in achieving the same results."</p>
              </div>
            </div>
            <div class="section_04_brands_body_item">
              <div class="section_04_brands_body_inner">
                <img class="img3" src="@/assets/landing-page/img/logo_rehub.png" />
                <p>"After engaging simplyBrand, we can now utilize a highly effective, scalable, and sustainable system to quickly discover issues and zero in on unauthorized activities, thus speeding up the process of enforcement."</p>
              </div>
            </div>
          </div>
        </div>
        <div class="section_04_bottom_link">
          <a href="#Request Demo">Experience Now</a>
        </div>
      </div>
    </div>

    <div class="section_05">
      <div class="section_05_content">
        <h2>Supported ecommerce channels</h2>
        <p>Monitoring 21,000 marketplaces and platforms with more added periodically</p>
        <img src="@/assets/landing-page/img/platform-logos.png" alt="platform" />
      </div>
    </div>

    <div class="section_06" id="requestdemo">
      <div class="section_06_content">
        <div class="section_06_header">
          <h2>It's never too early to start protecting your brand</h2>
          <p>Sign up for a demo to see our technology in action</p>
        </div>
        <div class="section_06_form">

          <el-form ref="form" :rules="rules" :model="form" size="small">
            <el-form-item prop="name" class="section_06_form_item">
              <el-input v-model="form.name" placeholder="Name*" class="input_01"></el-input>
            </el-form-item>
            <el-form-item class="section_06_form_item">
              <el-input v-model="form.email" type="email" placeholder="Email Address*" class="input_02"></el-input>
            </el-form-item>
            <el-form-item prop="tel" class="section_06_form_item">
              <el-input v-model="form.tel" type="tel" placeholder="Mobile No." class="input_03"></el-input>
            </el-form-item>
            <el-form-item class="section_06_form_item">
              <el-input v-model="form.company" placeholder="Company Name*" class="input_04"></el-input>
            </el-form-item>
            <el-form-item class="section_06_form_button">
              <el-button size="mini" type="primary" @click="sendEmail('form')" :loading="loading">Schedule a Demo</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <div class="site-footer">
      <div class="site-footer-content">
        <div class="site-footer-item site-footer-item-logo">
          <div class="site-footer-item-header">
            <img src="@/assets/landing-page/img/logo-hd.png" alt="simplyBrand" />
          </div>
          <div class="site-footer-body">
            <p>Making it our mission to make brand protection a more transparent, efficient process</p>
          </div>
        </div>
        <div class="site-footer-item site-footer-item-ul">
          <div class="site-footer-item-header">
            <!-- <h3>Product Features</h3> -->
          </div>
          <div class="site-footer-body">
            <!-- <ul>
              <li><a href="#">Price Monitor</a></li>
              <li><a href="#">Unauthorized Seller</a></li>
              <li><a href="#">Digital Defense</a></li>
              <li><a href="#">Infringements</a></li>
            </ul> -->
          </div>
        </div>
        <div class="site-footer-item site-footer-item-contact">
          <div class="site-footer-item-header">
            <h3>Contact</h3>
          </div>
          <div class="site-footer-body">
            <p>contact@simplybrand.com</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      loading: false,
      form: {
        name: '',
        from: '',
        tel: '',
        brand: '',
        company: '',
        email: '',
        href: ''
      },
      rules: {
        name: [
          { required: true, message: 'Name', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: 'Mobile No.', trigger: 'blur' },
        ],
      },
      showmobilemenu: false
    }
  },
  mounted(){

    /**
     * 添加客服图标
     */
    // let kchatid = '1040402'
    // let script = document.createElement('script')
    // script.type = 'text/javascript'
    // script.src = 'https://assets-cdn.kf5.com/supportbox/main.js?' + (new Date).getDay()
    // script.id = 'kf5-provide-supportBox'
    // script.charset = "utf-8"
    // script.setAttribute('kchat-id', kchatid)
    // script.setAttribute('kf5-domain', 'simplybrand.kf5.com')
    // document.getElementsByTagName('head')[0].appendChild(script)

  },
  methods: {

    sendEmail: function(formName){
      let that = this
      that.form.from = that.$route.query.ref == undefined ? '非推广来源' : that.$route.query.ref
      that.form.href = window.location.href
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true
          // let url = '//similarpic.simplybrand.com/api/userInfo/sendMail'
          let url = '/sendMail'
          $.ajax(url, {
            type: "POST",
            data: that.form,
            success: function(data) {
              console.log(data)
              that.showform = false
              that.loading = false
              that.form = {}
              that.$message({
                showClose: true,
                message: 'Success',
                type: 'success'
              })
            },
            error: function(response) {
              console.log(response)
              that.$message.error('Err')
            }
          })
        } else {
          this.$message.error('Err')
          return false
        }
      })
    },

    showmenu: function(){
      let that = this
      let _current = that.showmobilemenu
      console.log(_current)
      if(_current == false){
        that.showmobilemenu = true
      }else{
        that.showmobilemenu = false
      }
    },
  }
}
</script>
